import { Email } from '../../types/email'
import { Vendor } from '../../types/vendor'
import EmailItem from './EmailItem'

interface EmailListProps {
  emails: Email[]
  selectedEmailId: string | null
  onSelectEmail: (email: Email) => void
  vendorMap?: Map<string, Vendor>
}

export default function EmailList({
  emails,
  selectedEmailId,
  onSelectEmail,
  vendorMap
}: EmailListProps) {
  if (emails.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-500">
        <p>No emails found</p>
      </div>
    )
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {emails.map((email) => (
        <EmailItem
          key={email.id}
          email={email}
          isSelected={email.id === selectedEmailId}
          onClick={() => onSelectEmail(email)}
          autoDeleteDays={email.vendorId ? vendorMap?.get(email.vendorId)?.autoDeleteAfterDays : undefined}
        />
      ))}
    </div>
  )
}
